import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './app.js';
// Inter selbst gehostet wie in der Content-Factory (next/font, Build-Zeit statt Laufzeit-Anfrage):
// Ohne sie fiel die Seite auf Arial zurueck, das kein Halbfett kennt (Rueckmeldung 2026-10-13).
import '@fontsource-variable/inter';
import './theme.css';

const wurzel = document.getElementById('root');
if (!wurzel) throw new Error('Element #root fehlt in index.html.');

createRoot(wurzel).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
